import { createEntityActions } from 'next/lib/collections';

export const TYPE = 'account';

export const { patterns, update, reject, flush, append } =
  createEntityActions(TYPE);
